<template>
  <div class="scene tip-page" ref="playerWindow">
    <div
      class="tip-page-top"
      title="按住可拖动弹窗"
      @mousedown="handleDragStart($event)"
    >
      <span
        >出入口
        <span style="margin-left: 10px"> {{ sceneInfo.sceneName }} </span></span
      >
      <span class="tip-icon">
        <el-tooltip
          class="item"
          effect="dark"
          content="关闭"
          placement="top-start"
        >
          <i @click="handleCloseTip" class="el-icon-close"></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          content="缩放"
          placement="top-start"
        >
          <i
            class="el-icon-full-screen"
            @click="handleScreen"
            style="margin: 0 10px"
          >
          </i>
        </el-tooltip>
      </span>
    </div>
    <div
      class="tip-page-content scene-Screen"
      :id="isShowRight && 'showSearch'"
    >
      <div class="ocx-box">
        <playerBox ref="player" playBoxClass="realTime"></playerBox>
      </div>
      <div class="list-content">
        <div style="padding: 3px 16px">出入口设备</div>
        <el-scrollbar style="height: 89%">
          <div
            class="list-item"
            style="padding: 10px"
            v-for="(items, index) in deviceList"
            :key="index"
          >
            <div class="item-title" @click="items.show = !items.show">
              <span>
                {{ items.name }}
              </span>
              <el-button
                v-if="items.children.length"
                type="text"
                :class="items.show ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
              ></el-button>
              <span v-else style="color: gray">无设备信息</span>
            </div>
            <el-collapse-transition>
              <ul class="itemChildren" v-show="items.show">
                <li
                  v-for="(item, childrenIndex) in items.children"
                  :key="childrenIndex"
                  :class="[
                    'list-text',
                    item.deviceMark == 26 ? 'list-text__other' : '',
                  ]"
                >
                  <span class="list-name"
                    >{{ item.deviceName }}
                    <span v-if="item.deviceMark == 26">( 语音立柱 )</span>
                  </span>
                  <div v-if="item.deviceMark == 26" class="list-other">
                    <span class="list-name">
                      {{ item.targetDeviceName }}
                      <span>( 监听主机 )</span>
                    </span>

                    <span style="display: flex">
                      <el-button
                        type="text"
                        v-if="item.deviceMark == 26"
                        @click="handleActionC(item, 0)"
                        size="mini"
                      >
                        <img
                          title="开启对讲"
                          class="icon"
                          src="@src/common/assets/images/语音.png"
                          alt=""
                        />
                      </el-button>
                      <el-button
                        type="text"
                        title="关闭对讲"
                        v-if="item.deviceMark == 26"
                        @click="handleActionC(item, 1)"
                        icon="el-icon-switch-button"
                      >
                      </el-button>
                    </span>
                  </div>
                  <span style="display: flex" v-if="item.deviceMark != 26">
                    <el-button
                      type="text"
                      v-if="item.deviceMark == 22"
                      @click="handleActionA(item)"
                      size="mini"
                    >
                      <img
                        title="操作闸机"
                        class="icon"
                        src="../../../common/assets/images/人道闸.png"
                        alt=""
                    /></el-button>
                    <el-button
                      type="text"
                      v-if="item.deviceMark == 25"
                      @click="handleActionB(item)"
                      size="mini"
                    >
                      <img
                        class="icon"
                        title="操作道闸"
                        src="../../../common/assets/images/车道闸.png"
                        alt=""
                      />
                    </el-button>
                  </span>
                </li>
              </ul>
            </el-collapse-transition>
          </div>
        </el-scrollbar>
        <div style="text-align: center;margin:10px 0" v-if="sceneType == 2">
          <el-button type="primary" size="small" @click="handleCloseEvent">
            关闭事件
          </el-button>
        </div>
        <!-- <div
          style="top: 40%"
          :title="(!isShowRight ? '展开' : '收起') + '操作栏'"
          :class="[
            'map-blur-panel__expand-button right iconfont-lunan',
            !isShowRight
              ? 'icon-lunan-shousuocaidan-copy'
              : 'icon-lunan-shousuocaidan',
          ]"
          @click="isShowRight = !isShowRight"
        ></div> -->
        <!-- <div
          style="top: 60%"
          title="通行记录"
          class="map-blur-panel__expand-button right el-icon-tickets"
          @click="handleGate"
        ></div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { api } from "../api";
import playerBox from "@src/modules/gatewayManager/components/player-box.vue";
export default {
  components: { playerBox },
  name: "SceneDetails",
  props: {
    sceneType: {
      type: Number,
      default: 1,
    },
    sceneCode: {
      type: String,
      default: "",
    },
  },
  watch: {
    // sceneCode: {
    //   // handler(val) {
    //   //   if (!val) {
    //   //     return;
    //   //   }
    //   //   this.getSceneInfo();
    //   // },
    //   immediate: true,
    // },
  },
  data() {
    return {
      playPlugin: this.$store.getters.playInfo, //播放器信息
      AccessToken: "", //插件鉴权token
      windowNumber: 4,
      screenWnd: 0, ///放大的窗口序号
      maxWnd: 6,
      labelSpan: 11,
      data: {}, //渲染数据,
      isShowRight: false,
      showGatePanel: false,
      deviceList: [
        {
          name: "出入口车辆道闸设备",
          show: false,
          children: [],
        },
        { name: "出入口人行闸机设备", show: false, children: [] },
        { name: "出入口语音对讲设备", show: false, children: [] }, //广播
      ],
      deviceInfo: {
        playId: "61010000001310000001",
        playTitle: "测试窗口",
      }, //设备信息
      playBoxId: {}, //存储窗口信息
      sceneInfo: {}, //场景信息
    };
  },
  mounted() {
    this.getSceneInfo();
  },
  methods: {
    handleCloseEvent() {
      this.$emit("resetDispose", "scene");
    },
    handleGate() {
      this.showGatePanel = !this.showGatePanel;
      this.$emit("handleShowGateDetail");
    },
    // 操作闸机
    handleActionA(item) {
      let params = {
        openType: "1",
        deviceIdList: [item.deviceId],
      };
      this.$fetch(api.controlTurnstilegate, params).then((res) => {
        if (res.success) {
          this.$message.success(item.deviceName + "[开闸成功]");
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 操作道闸
    handleActionB(item) {
      this.$fetch(api.controlVehicleBarrier, {
        thirdDeviceId: item.thirdDeviceId,
        cmdType: 1,
      }).then((res) => {
        if (res.success) {
          this.$message.success(item.deviceName + "[道闸操作成功]");
        } else {
          this.$message.error(res.msgContent || "道闸操作失败");
        }
      });
    },
    // 操作语音设备
    handleActionC(item, type) {
      console.log(item);
      // thirdDeviceId 立柱
      // targetThirdDeviceId:主机
      let params = {
        // 源终端ID，话筒
        sourceTerminalId: item.targetThirdDeviceId,
        // 0 开始 1 停止
        stop: type,
        commnandType: 1,

        //目标终端ID列表，广播设备
        targetTerminalIdList: [item.thirdDeviceId],
      };
      this.$fetch(api.manualRemoteCall, params).then((res) => {
        if (res.success) {
          this.$message.success(item.deviceName + "[语音设备操作成功]");
        } else {
          this.$message.error(res.msgContent || "语音设备操作失败");
        }
      });
    },
    getSceneInfo() {
      this.$fetch(api.querySceneDetail, {
        sceneCode: this.sceneCode,
      }).then((res) => {
        if (res.success) {
          this.sceneInfo = res.returnObj;
          let deviceMap = this.sceneInfo.deviceSceneDetailMap;
          let deviceNum = deviceMap[18].length;
          this.deviceList[0].children = deviceMap[25] || [];
          this.deviceList[1].children = deviceMap[22] || [];
          this.deviceList[2].children = deviceMap[26] || [];
          this.$nextTick(() => {
            if (deviceNum > 0) {
              let windowNumber = deviceNum == 1 ? 1 : deviceNum < 9 ? 4 : 9;
              this.$refs.player.windowNumber = windowNumber;
              deviceMap[18].forEach((item, index) => {
                this.$refs.player.handlePlayLive(
                  {
                    thirdCameraId: item.thirdDeviceId,
                    name: item.deviceName,
                  },
                  index + 1
                );
              });
            }
          });
        } else {
          this.$message.error(res.msgContent || "获取出入口场景详情失败");
        }
      });
    },
    handleDragStart(event) {
      const startX = event.clientX;
      const startY = event.clientY;
      const pw = this.$refs.playerWindow;
      const rectBox = pw.getBoundingClientRect();
      let moveX = 0;
      let moveY = 0;
      let flag = true;
      const moveEvent = (e) => {
        if (flag) {
          moveX = e.clientX - startX;
          moveY = e.clientY - startY;
          pw.style.left = rectBox.left - 100 + moveX + "px";
          pw.style.top = rectBox.top - 100 + moveY + "px";
        }
      };
      document.body.addEventListener("mousemove", moveEvent);
      const mouseUp = () => {
        flag = false;
        document.body.removeEventListener("mousemove", moveEvent);
        document.body.removeEventListener("mouseup", mouseUp);
      };
      document.body.addEventListener("mouseup", mouseUp);
    },
    handleScreen() {
      let screen = document.getElementsByClassName("scene-Screen");
      console.log(screen[0].classList);
      screen[0].classList.toggle("screen");
    },
    handleCloseTip() {
      this.$refs.player.handleStopAllVideo();
      this.deviceList.forEach((el) => {
        el.show = false;
      });
      this.$nextTick(() => {
        this.$emit("handleCloseScene");
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
:deep .el-icon-switch-button {
  font-size: 20px;
}
.flex-Between {
  display: flex;
  justify-content: space-between;
}
.tip-page {
  z-index: 5;
  user-select: none;
  position: absolute;
  left: 100px;
  top: 100px;
  padding: 0 16px 16px;
  height: auto;
  font-size: 15px;
  border-radius: 5px;
  @include set_theme_color(background-color, map-panel-content);
  backdrop-filter: blur(2px);
  &-top {
    border-left: 5px solid #407aee;
    padding-left: 10px;
    height: 20px;
    line-height: 20px;
    margin-top: 10px;
    cursor: move;
    @extend .flex-Between;
    i {
      cursor: pointer;
      font-size: 18px;
      color: #fff;
    }
  }

  &-content {
    width: 900px;
    height: 550px;
    margin-top: 12px;
    display: flex;
    position: relative;
    overflow: hidden;
    &.screen {
      width: 1280px !important;
    }
  }
  #showSearch {
    overflow: unset;
  }

  &-bottom {
    padding: 5px;
    text-align: center;
  }
  .ocx-box {
    height: 100%;
    flex: 1;
  }
  .list-content {
    height: 100%;
    width: 30%;
    max-width: 400px;
    // position: absolute;
    // right: -300px;
    background: #181f2e;
    transition: right 0.3s;
    padding: 12px 1px;
    &.show {
      // right: 0px;
    }
    .el-button {
      // font-size: 15px;
      color: #fff !important;
    }
    .itemChildren {
      background: #1e2534;
      .icon {
        width: 22px;
      }
    }
    .item-title {
      color: #fff;
      background: #0d121c;
      padding: 8px 9px;
    }
    .list-text {
      padding: 8px 9px;
      color: #9aa6c1;
      background: #1e2534;
      border-bottom: 1px solid #3b4253;
      &:hover {
        background: rgba(13, 18, 28, 1);
      }
      // &.check {
      //   background: #0d121c;
      // }
    }
    .list-other {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid #3b4253;
    }
    .list-text:last-child {
      border-bottom: none;
    }
    .item-title,
    .list-text {
      font-size: 14px;
      height: 40px;
      font-weight: 400;
      // line-height: 14px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &__other {
        height: auto !important;
        min-height: 40px !important;
        flex-wrap: wrap !important;
        .list-name {
          height: 40px;
          line-height: 40px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }
    }
  }
}
</style>
